import type { dealerSearchIncoming } from "@dealer-center/ddc-pages-account-search-interface";
import {
  lambdaError,
  lambdaTimeoutError
} from "@dealer-center/ddc-pages-account-search-interface";
import { getBulkUrlToUse, getOptions } from "./helper";

export const bulkFetch = async (searchRequest: dealerSearchIncoming) => {
  const options = getOptions(searchRequest);
  const url = getBulkUrlToUse();
  const result = await fetch(url, options);
  if (result.status === 502 || result.status === 504) {
    return lambdaTimeoutError;
  } else if (!result.ok) {
    return lambdaError;
  } else {
    const response = result.json() as Promise<string>;
    return response;
  }
};
